import i18next from 'i18next';

i18next.addResources('es_CL', 'ProductInstructions', {
  addNote: 'Agrega una nota',
  instructions: 'Comentarios:',
  maxLengthReached: 'Los comentarios no pueden exceder 100 caracteres'
});
